import { render, staticRenderFns } from "./SalesOrder.vue?vue&type=template&id=2d4991bd"
import script from "./SalesOrder.vue?vue&type=script&lang=js"
export * from "./SalesOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d4991bd')) {
      api.createRecord('2d4991bd', component.options)
    } else {
      api.reload('2d4991bd', component.options)
    }
    module.hot.accept("./SalesOrder.vue?vue&type=template&id=2d4991bd", function () {
      api.rerender('2d4991bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/SalesOrder.vue"
export default component.exports